import React, { useState } from "react";

const KIND = { base: "Base suite", suite: "Suite add-on", addon: "Add-on", free: "Free / trial", unknown: "Unmapped" };

export default function SkuTable({ skus }) {
  const [showZero, setShowZero] = useState(false);
  const rows = skus.filter((s) => showZero || s.consumed > 0 || s.enabled > 0);
  return (
    <section className="ws-card glass" data-testid="sku-table">
      <div className="ws-card-head">
        <h2>Subscribed SKUs</h2>
        <label className="ws-check small">
          <input type="checkbox" checked={showZero} onChange={(e) => setShowZero(e.target.checked)} /> show SKUs with no seats
        </label>
      </div>
      <div className="ws-table-wrap">
        <table className="ws-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Type</th>
              <th className="num">Purchased</th>
              <th className="num">Assigned</th>
              <th className="num">Unassigned</th>
              <th className="num">On disabled</th>
              <th className="num">Inactive 90d</th>
              <th>Utilisation</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => {
              const pct = s.enabled ? Math.min(100, Math.round((s.consumed / s.enabled) * 100)) : 0;
              return (
                <tr key={s.sku_id} data-testid={`sku-row-${s.part_number}`}>
                  <td>
                    <div className="sku-name">{s.name}</div>
                    <div className="sku-part mono">
                      {s.part_number}
                      {s.plan_id ? <span className="mini-chip ok">matrix: {s.plan_id}</span> : s.addon_name ? <span className="mini-chip">{s.addon_name}</span> : null}
                    </div>
                  </td>
                  <td>
                    <span className={`mini-chip kind-${s.kind}`}>{KIND[s.kind] || s.kind}</span>
                  </td>
                  <td className="num mono">{s.enabled.toLocaleString()}</td>
                  <td className="num mono">{s.consumed.toLocaleString()}</td>
                  <td className={`num mono ${s.unassigned > 0 && s.kind !== "free" ? "warn" : ""}`}>{s.unassigned.toLocaleString()}</td>
                  <td className={`num mono ${s.assigned_disabled ? "warn" : ""}`}>{s.assigned_disabled}</td>
                  <td className="num mono">{s.assigned_inactive}</td>
                  <td>
                    <div className="util">
                      <span style={{ width: `${pct}%` }} className={pct < 80 ? "low" : ""} />
                    </div>
                    <span className="util-pct mono">{pct}%</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
